import { instanceApi } from '../../../services';
import { TradingActivitiesEmailReportRequest, TradingRequestModel } from './TradingActivitiesReportModel';

export const getTradingActivitiesReport = (request: TradingRequestModel): Promise<any> => instanceApi.post('api/analysisreport/clientstradingactivitiesreport', request);

export const sendEmailTradingAvtivities = (data: TradingActivitiesEmailReportRequest): Promise<any> => instanceApi.post('api/analysisreport/sendemailtradingactivities', data);
